// Example Google URLs shown on the home and on /google-location-changer/ (A04).
// Built with the same function the tool uses, so the published examples always
// match what the tool really opens.
import { buildSerpUrl, uuleV2FromLatLng } from './serpUrl';

// London as Nominatim returns it ("Greater London"). The example is a country +
// city search, so it carries a coordinate (v2) uule: Google ignored every
// place-name (v1) uule we tested (LRN-029). The real tool stamps the current
// time into the uule; the example pins one timestamp so the link, the static
// HTML and the hydrated page stay identical.
export const LONDON = { lat: '51.5074456', lng: '-0.1277653' };
export const LONDON_TS = 1791309111400000;

export const UK_UULE = uuleV2FromLatLng(parseFloat(LONDON.lat), parseFloat(LONDON.lng), {
  timestamp: LONDON_TS,
});

// Built by the real buildSerpUrl(); only the uule is swapped for the pinned one.
export const UK_URL = (() => {
  const url = new URL(
    buildSerpUrl({
      keyword: 'running shoes',
      countryCode: 'GB',
      countryLabel: 'United Kingdom',
      coords: LONDON,
      language: 'en',
      num: 10,
      safe: false,
    })
  );
  url.searchParams.set('uule', UK_UULE);
  return url.toString();
})();
